export type Size = "XS" | "S" | "M" | "L" | "XL" | "XXL";
export type Fit = "Slim" | "Regular" | "Oversized";
export type BodyType = "Slim" | "Athletic" | "Regular" | "Curvy" | "Plus";

export type Product = {
  id: string;
  name: string;
  brand: string;
  category: string;
  price: number;
  rating: number;
  reviews: number;
  colors: { name: string; hex: string }[];
  sizes: Size[];
  materials: string[];
  fits: Fit[];
  images?: { url: string; alt?: string; sort_order?: number }[];
};

export const SIZES: Size[] = ["XS", "S", "M", "L", "XL", "XXL"];
export const FITS: Fit[] = ["Slim", "Regular", "Oversized"];
export const BODY_TYPES: BodyType[] = ["Slim", "Athletic", "Regular", "Curvy", "Plus"];

export const CATALOG: Product[] = [
  {
    id: "prod-1",
    name: "Classic Linen Shirt",
    brand: "Island Linen",
    category: "Shirts",
    price: 69.99,
    rating: 4.5,
    reviews: 120,
    colors: [
      { name: "White", hex: "#FFFFFF" },
      { name: "Sky Blue", hex: "#87CEEB" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Linen"],
    fits: ["Regular"]
  },
  {
    id: "prod-2",
    name: "Beach Cover-Up Tunic",
    brand: "Sandy Toes",
    category: "Tops",
    price: 45.0,
    rating: 4.2,
    reviews: 85,
    colors: [
      { name: "Turquoise", hex: "#40E0D0" },
      { name: "Coral", hex: "#FF7F50" }
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    materials: ["Cotton Voile"],
    fits: ["Oversized"]
  },
  {
    id: "prod-3",
    name: "Carnival Mesh Top",
    brand: "Soca Fete",
    category: "Tops",
    price: 55.0,
    rating: 4.7,
    reviews: 200,
    colors: [
      { name: "Neon Yellow", hex: "#CCFF00" },
      { name: "Hot Pink", hex: "#FF69B4" }
    ],
    sizes: ["S", "M", "L"],
    materials: ["Polyester Mesh"],
    fits: ["Slim"]
  },
  {
    id: "prod-4",
    name: "Bajan Breeze Button-Down",
    brand: "Bajan Breeze",
    category: "Shirts",
    price: 75.0,
    rating: 4.4,
    reviews: 95,
    colors: [
      { name: "Seafoam Green", hex: "#9FE2BF" },
      { name: "Sand", hex: "#C2B280" }
    ],
    sizes: ["M", "L", "XL"],
    materials: ["Linen"],
    fits: ["Regular"]
  },
  {
    id: "prod-5",
    name: "Tropical Print Hoodie",
    brand: "Tropical Threads",
    category: "Hoodies",
    price: 89.99,
    rating: 4.3,
    reviews: 45,
    colors: [
      { name: "Palm Green", hex: "#2E8B57" },
      { name: "Sunset Orange", hex: "#FF4500" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Cotton Blend"],
    fits: ["Regular"]
  },
  {
    id: "prod-6",
    name: "Lightweight Rain Jacket",
    brand: "Caribbean Shield",
    category: "Jackets",
    price: 110.0,
    rating: 4.6,
    reviews: 60,
    colors: [
      { name: "Navy", hex: "#000080" },
      { name: "Olive", hex: "#808000" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Recycled Polyester"],
    fits: ["Regular"]
  },
  {
    id: "prod-7",
    name: "Sunshine & Rum Sundress",
    brand: "Sunshine & Rum",
    category: "Dresses",
    price: 59.99,
    rating: 4.8,
    reviews: 150,
    colors: [
      { name: "Flamingo Pink", hex: "#FC8EAC" },
      { name: "Mint", hex: "#98FF98" },
      { name: "Yellow", hex: "#FFFF00" }
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    materials: ["Rayon"],
    fits: ["Regular"]
  },
  {
    id: "prod-8",
    name: "Island Goddess Maxi Dress",
    brand: "Island Goddess",
    category: "Dresses",
    price: 85.0,
    rating: 4.5,
    reviews: 102,
    colors: [
      { name: "Ocean Blue", hex: "#00BFFF" },
      { name: "Sunset Coral", hex: "#FF6F61" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Chiffon"],
    fits: ["Regular"]
  },
  {
    id: "prod-9",
    name: "Carnival Jumpsuit",
    brand: "Bacchanal Babe",
    category: "Dresses",
    price: 99.99,
    rating: 4.9,
    reviews: 230,
    colors: [
      { name: "Glitter Gold", hex: "#FFD700" },
      { name: "Electric Blue", hex: "#0000FF" }
    ],
    sizes: ["XS", "S", "M", "L"],
    materials: ["Spandex", "Nylon"],
    fits: ["Slim"]
  },
  {
    id: "prod-10",
    name: "Island Linen Trousers",
    brand: "Island Linen",
    category: "Pants",
    price: 79.99,
    rating: 4.4,
    reviews: 78,
    colors: [
      { name: "Natural Linen", hex: "#FAF0E6" },
      { name: "Soft White", hex: "#F5F5F5" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Linen"],
    fits: ["Regular"]
  },
  {
    id: "prod-11",
    name: "Resort Wear Shorts",
    brand: "Palm & Reef",
    category: "Pants",
    price: 50.0,
    rating: 4.2,
    reviews: 64,
    colors: [
      { name: "Coral Reef", hex: "#FF7F50" },
      { name: "Aqua", hex: "#00FFFF" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Cotton Twill"],
    fits: ["Regular"]
  },
  {
    id: "prod-12",
    name: "TropiFit Active Set",
    brand: "TropiFit",
    category: "Activewear",
    price: 89.0,
    rating: 4.5,
    reviews: 130,
    colors: [
      { name: "Tropical Teal", hex: "#008080" },
      { name: "Berry", hex: "#B8265E" }
    ],
    sizes: ["XS", "S", "M", "L", "XL"],
    materials: ["Polyester", "Spandex"],
    fits: ["Slim"]
  },
  {
    id: "prod-13",
    name: "Yoga Crop Top",
    brand: "TropiFit",
    category: "Tops",
    price: 40.0,
    rating: 4.3,
    reviews: 95,
    colors: [
      { name: "Lavender", hex: "#E6E6FA" },
      { name: "Ocean Mist", hex: "#B0E0E6" }
    ],
    sizes: ["XS", "S", "M", "L"],
    materials: ["Nylon", "Spandex"],
    fits: ["Slim"]
  },
  {
    id: "prod-14",
    name: "Rash Guard Long Sleeve",
    brand: "Surf Soul",
    category: "Activewear",
    price: 65.0,
    rating: 4.6,
    reviews: 45,
    colors: [
      { name: "Cobalt Blue", hex: "#0047AB" },
      { name: "Sunflower", hex: "#FFDA03" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Polyester", "Spandex"],
    fits: ["Slim"]
  },
  {
    id: "prod-15",
    name: "Linen Blend Cardigan",
    brand: "Island Breeze",
    category: "Jackets",
    price: 95.0,
    rating: 4.4,
    reviews: 35,
    colors: [
      { name: "Cream", hex: "#FFFDD0" },
      { name: "Dusty Rose", hex: "#DCA9A0" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Linen-Viscose Blend"],
    fits: ["Oversized"]
  },
  {
    id: "prod-16",
    name: "Carnival Feather Top",
    brand: "Masquerade",
    category: "Tops",
    price: 75.0,
    rating: 4.8,
    reviews: 180,
    colors: [
      { name: "Peacock", hex: "#33A1C9" },
      { name: "Magenta", hex: "#FF00FF" }
    ],
    sizes: ["XS", "S", "M", "L"],
    materials: ["Feathers", "Mesh"],
    fits: ["Slim"]
  },
  {
    id: "prod-17",
    name: "Batik Print Shirt",
    brand: "Kaya Styles",
    category: "Shirts",
    price: 68.0,
    rating: 4.5,
    reviews: 110,
    colors: [
      { name: "Indigo", hex: "#4B0082" },
      { name: "Terracotta", hex: "#DD7B4E" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Cotton"],
    fits: ["Regular"]
  },
  {
    id: "prod-18",
    name: "Tropical Satin Bomber Jacket",
    brand: "Soca Streetwear",
    category: "Jackets",
    price: 130.0,
    rating: 4.7,
    reviews: 85,
    colors: [
      { name: "Emerald", hex: "#50C878" },
      { name: "Gold", hex: "#FFD700" }
    ],
    sizes: ["S", "M", "L", "XL"],
    materials: ["Satin", "Polyester Lining"],
    fits: ["Regular"]
  }
];

export function productImagePath(id: string): string {
  return `/images/products/${id}.svg`;
}

export function findProduct(id: string): Product | undefined {
  return CATALOG.find(product => product.id === id);
}
